module.exports = __webpack_public_path__ + "img/header-sto.45c2227a.svg";